import './Window';
import { hasAndroidBus, hasIosBus } from '@shared/vanilla-utils';
import { getToken } from '@shared/auth';

export type DownloadWithGeorgeGo = {
    method: string;
    url?: string;
    headers?: any;
    payload?: string;
    canSkipAuthHeader?: boolean;
};

export function isInAndroidWebView(): boolean {
    return (
        !!window.isGeorgeWebView ||
        typeof window.georgeActions?.downloadFile === 'function' ||
        window.cordova?.platformId === 'android' ||
        hasAndroidBus()
    );
}

export function isInIOSWebView(): boolean {
    return (
        !!window.webkit?.messageHandlers?.isGeorgeWebView ||
        typeof window.webkit?.messageHandlers?.downloadFile?.postMessage === 'function' ||
        window.cordova?.platformId === 'ios' ||
        hasIosBus()
    );
}

export function isInCordova(): boolean {
    return !!window.cordova;
}

function isInVanilla(): boolean {
    return window.location.pathname?.endsWith('/vanilla.html');
}

export function isInWebView(): boolean {
    return isInAndroidWebView() || isInIOSWebView() || isInCordova() || isInVanilla();
}

export function downloadFile({
    method,
    url = '',
    headers = {},
    payload,
    canSkipAuthHeader,
}: DownloadWithGeorgeGo): boolean {
    if (!url) {
        return false;
    }

    const authToken = getToken(); // TODO move getToken into auth package

    const params = {
        method,
        url,
        headers: {
            ...headers,
            ...(!authToken && canSkipAuthHeader ? {} : { Authorization: `Bearer ${authToken}` }),
        },
        payload,
    };

    if (isInAndroidWebView()) {
        window.georgeActions?.downloadFile?.(JSON.stringify(params));
        return true;
    }

    if (isInIOSWebView()) {
        window.webkit?.messageHandlers?.downloadFile?.postMessage?.(params);
        return true;
    }

    return false;
}
